/* eslint-disable jsx-a11y/anchor-is-valid */
import Aside from "../../components/Sidebar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ScrollUp from "../../components/ScrollUp";
import MainTitle from "../../components/MainTitle";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Articles = () => {
  return (
    <>
      <div className="page d-flex">
        <Aside />
        <div className="content w-full">
          <Header />
          <MainTitle title="المقالات" />
          <div
            className="container-8"
            style={{
              paddingBottom: "60px",
            }}
          >
            <div className="wb-1 m-wb bg-white p-10 m-10">
              <div className="inf inf-2">
                <h3 className="my-h3-2 my-h3">دائما ابحث | Always Search</h3>
              </div>
            </div>
            <pre className="my-pre">
              دائما ابحث | Always Search هتغير حياتك ! مقولة مشهورة من استاذنا
              الفاضل اسامه الزيرو وهيا Always Search دائما ابحث ! رغم ان الكلمه
              دي لا تتكون من اكتر من كلمتين بس لو فهمت الكلمتين دول كويس ممكن
              تغير حياتك .. ازاي يا راسكو ؟ تعال اشرحلك : خلينا نقسم البحث 3
              حاجات 1 - البحث بسبب مشكله وجهتك 2 - البحث لمعرفه حاجه جديده 3 -
              البحث باستخدام الذكاء الاصطناعي واقراء لاخر البوست في حجت هتفيدك
              جدا وهتوفر عليك وقت كبير ان شاء الله . - صل علي النبي 💜 1 - البحث
              بسبب مشكله ! ودا لما مشكله بتظهرلك وندي مثال لمشكله في ال vscode
              ظهرتلك ومكتوب فيها "An error occurred while trying to create a
              file in the destination directory: Access is denied." الشخص العادي
              ال مش فاهم يعني اي يبحث دائما هيمر بالسيناريوه دا : هيخش اي جروب
              تبع المجال ال بيشتغلو ب ال vs code هينزل فيه المشكله البوست عقبال
              ما يتقبل قدامو مثلا ساعه الي 10 ساعات وفي بيوصل ل 12 ساعه كامله !
              ولسا عقبال لما الادمن يشوف البوست غير ان كل واحد في الكمنت ممكن
              يقلك علي هبده من عندو وكل واحد يوديك في مسار مختلف. فا انت متخيل
              10 ساعات علشان مشكله تقدر تحلها لو انت فاهم يعني اي تبحث دائما ..
              غير ان مثلا الخطا دا ظهرلك وانت شغال ومحتاج تسلم المشورع دا علشان
              تسلمو للعميل في الوقت ال انت محددو فا قصه . طب احلها ازاي يعم
              راسكو ؟ انا ذات نفسي مش عارف والله : بس هعمل حاجه جميله اوي هاخد
              اسم الخطاء دا وهبحث فيه في google او youtube بكل بساطه كدا ؟ اه
              والله بكل بساطه كدا .. لو بحثت بالخطاء دا كدا كوبي بيست في جوجل :
              "An error occurred while trying to create a file in the
              destination directory: Access is denied." هيظهرلك مقاله بتتكلم عن
              الموضوع و في نفس الوقت فيديو تحتو شارح الموضوع دا بردو بالخطوات !
              طب انا مش بفهم انجليزي ؟ و المقالات كلها بانجليزي هتحمل اضافه
              اسمها google translate extension وتثبتها عندك و دي بتمكنك انك تقدر
              تترجم الموقع كامل الي الغه ال انت عايزها . وبالنسبه للفيديو فا انت
              مش محتاج تسمع حاجه انت بتشوف بس هوا بيعمل اي وهتطبق وراه .. و لو
              منفعتش تجرب فيديو تاني و هكذا لحد ما تحل المشكله دي . 2 - البحث
              لمعرفه حاجه جديده ! مثلا انت واحد محتاج تتعلم الفوتوشوب .. فا بكل
              بساطه والله هتكتب كورس فوتوشوب في منصه youtube بكل بساطه جدا
              هيظهرلك فيدوهات كتيره تقدر تشوف ال يرحيك و تابع معاه الكورس ال انت
              عايزو . طب عايز اعرف ازاي ابقي full stack في البرمجه ؟ بكل بساطه
              هتبحث عن رود ماب full stack وتشوف اكثر من فيديو شارح الموضوع وهتلم
              الموضوع و هتكو ن فاهم الدنيا ماشيه ازاي . طب ازاي ابداء في مجال
              البرمجه ؟ نفس القصه هتخش لليوتيوب وهتكتب فيه : ازاي ابداء في مجال
              البرمجه وهيظرهلك اكتر من فيديو تقدر تسمعو و هيفهموك الدنيا . و نفس
              القصه بقي في اي مجال انت عايزو . طب لو في كورس مدفوع وانت عايز
              الكورس دا وشايفو هيضف ليك ؟ في اي كورس مدفوع بيبقي كاتب اي الحجات
              ال هتدرسها .. الحجات دي هتخدها وتبحث عنها في اليوتيوب وهتلاقي في
              ناس شرحه اغلبيتها . وفي اي مجال انت فيه مش بتقدر توصل للمعولمات
              كلها من كورس حتي لو اتفرجت علي يجي 5 كورسات لنفس الحاجه ال انت
              بتتعلمها حتي البشمهندس اسامه بيقلك ابحث عن الحاجه دي و يديلك اسمها
              علشان يدربك عن الموضوع دا .. فا باالتالي تعود نفسك انك تبحث عن
              معلومه هتضيف ليك او حاجه هتسعدك في المجال سواء بقي عن طريق جوجل او
              تشوف فيديوهات برحتك بس دي هتضيف ليك كتير جدا . و حاجه هتفيدك جدا
              ان في اي مجال انت فيه حاول تبحث عن حاجه اسمها tricks .. الكلمه دي
              كفيله انك تخلي مستواك عالي جدا في حاجه انت بتعملها يعني مثلا انت
              لو فرونت اند هتبحث كدا "html and css tricks" في ناس عنده خبره ب ال
              7 سنين في المجال بتلخصلك حجات كتيره جدا ظهرت جديده في المجال ال
              انت شغال فيه و هتوفر عليك وقت كبير جدا و هتفرق عن الناس ال مش
              عارفه الحجات دي وجرب و هتعديلي . و نصيحه مني كدا ان شاء الله
              هتفيدك .. لما تيجي تبحث عن معلومه او حاجه نوعن ما مش مشهوره عندنا
              في العرب تبحث بالغه الاجنبيه زي مثلا انت محتاج ادوات هتسعدك في
              مجال ال هوا مثلا frontend .. فا انت لو بحثت بالغه العربيه فا في
              حجات كتيره مش هتقدر توصل ليها فا مثلا لو بحثت "ادوات للبرمجه" مش
              هيظهرلك القدر الكافي من الادوات ال تقدر تساعدك بل في بعض الحلات مش
              هيظهرلك حاجه ! فا بالتالي بنستخدم الغه الانجليزيه وهيا الغه
              السائده في معظم المجالات فا هنبحث بكلمه "Coding Tools" وشوف بقي
              المواقع ال هتظهرلك و تقدملك ادوات كتيره تقدر تساعدك في المجال طب
              انا يارسكو مش بعرف انجليزي كويس ؟ بكل بساطه هتخش موقع زي google
              translate وتكتب فيه الجمله ال انت عايز تبحث بيها للغه الاجنبيه و
              تقدر تتجرم اي حاجه انت عايزها . بعض الاسئله ال بتجيلي وببحث عنها
              ازاي ! السوال : راسكو عايز موقع اقدر احمل منو روسمات علشان
              استخدمها في الموقع بتاعي راسكو : "website download free art
              illustrator" السوال : راسكو عايز موقع اقدر ارفع عليه الموقع بتاعي
              بطريقه مجانيه راسكو : "best website can hosting my website for
              free" 3 - البحث باستخدام الذكاء الاصطناعي : ودا كنذ حرفيا لو عرفت
              تستغلو صح .. هوا انك تستخدم الذكاء الاصطناعي في انك تخليه مساعد
              ليك ازاي يارسكو ؟ هقلك دلوقتي كلنا طبعا عرفين chatgpt و هوا بكل
              بساطه chatbot بتقدر تسالو علي اي حاجه انت عايزها و هيرد عليك بشكل
              مختصر .. تقدر تستخدمو من الموقع الرسمي عادي او من الموقع دا poe .
              com دا بقي يا صحبي كنذ حرفيا و بستخدمو بشكل يومي حرفيا في انو يكون
              مساعد شخصي ليا .. يعني مثلا كان في error ظهرلي في ال react وقعت
              حرفيا ساعات ادور و ابحث في الموضوع ومعرفتش اوصل لحل .. فا قلت اعمل
              ايش ؟ خت الكود ال انا كاتبو عندي كلو وضفتو في chatgpt .. وكتبت ليه
              حليلي المشكله ال موجوده في الكود دا : لقيتو بقي فسرلي الكود بيعمل
              اي و الغلط فين بالظبط و الحل بتاعو اي و كل حاجه حرفيا عن الخطاء ال
              ظهر و سببو ايش . واستخدمتو بردو في حيله ذكيه جدا .. كان في موقع
              انا عاملو ب pure css .. فا العميل قلي عايزك تحوله ل bootstrap قولت
              باااس كدا اخت الاكودا لكل div عندي في المشروع و كتبت ل chatgpt ..
              حولي التنسيق دا لكلاسات bootstrab .. وفعلا حولي الكود ال كاتبو
              لكلاسات ال bootstrap وبدات اضفها عندي في المشروع هيسيبك بقي تتخيل
              مع نفسك تقدر تعمل اي تاني دي بس نبذه بسيطه عن استخدامتي لل chatgpt
              . وبس كدا كان معكم راسكو اشوفكم في بوست جديد قريبا ان شاء الله وصل
              علي النبي 💜 وشارك ارئيك في التعليقات لو وصلت للنقطه دي 💜 -وشارك
              البوست لعل تعرف حد معملومه جديد ونتقاسم الاجر 💜
            </pre>
          </div>
          <ScrollUp />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Articles;
